import { createContext, useContext } from "react";

type Context = {
    trackLinkClick: (pageId: number, href: string) => void;
}

export const StatsContext = createContext<Context>({} as Context);

export const useStats = () => useContext(StatsContext);
